import { Badge, Button, Col, Row } from "react-bootstrap";
import { RouteModel } from "../../domain/models/routeModel";
import { useRouteTruckLayout } from "../../infrastructure/hooks/useRouteTruckLayout";
import { Plus } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { uniqueId } from "lodash";

export const RouteTruckLayout = ({
  route,
  updateRouteCustom,
}: {
  route: RouteModel;
  updateRouteCustom: () => void;
}) => {
  const {
    totalRows,
    totalColumns,
    setSelected,
    getSelected,
    packingSlips,
    addEmptyToSelected,
    addColumn,
    addRow,
    setCustom,
  } = useRouteTruckLayout(route);
  const { t } = useTranslation("common");

  return (
    <Row>
      <Col md="4">
        {packingSlips?.length !== 0 && (
          <div className={"mb-2"}>
            <Badge bg={"primary"} className={"me-2"}>
              {t("packingSlips.legend.toBeDivided")}
            </Badge>
            <Badge bg={"info"} className={"me-2"}>
              {t("packingSlips.legend.deliver")}
            </Badge>
            <Badge bg={"secondary"} className={"me-2"}>
              {t("packingSlips.legend.pickup")}
            </Badge>
          </div>
        )}

        {packingSlips?.map(({ packingSlip, amount }) => {
          const deliveryAmount = Number(
            packingSlip.requests?.filter((item) => item.type === "deliver")
              .length ?? 0,
          );
          const pickupAmount = Number(packingSlip.pickup_amount ?? 0);

          return (
            <Row key={packingSlip.id} className="mb-2">
              <Col md={8}>{packingSlip.relation.name}</Col>
              <Col md={4} className={"d-flex gap-1 align-items-center"}>
                <Badge
                  bg={amount > 0 ? "primary" : "success"}
                  className={"mw-24"}
                >
                  {amount}
                </Badge>
                <Badge bg={"info"} className={"mw-24"}>
                  {deliveryAmount}
                </Badge>
                <Badge bg={"secondary"} className={"mw-24"}>
                  {pickupAmount}
                </Badge>
              </Col>
            </Row>
          );
        })}
      </Col>
      <Col md="8">
        <div className="d-flex flex-column truck-layout">
          {Array.from({ length: totalRows ?? 0 }).map((_, rowIndex) => {
            return (
              <div key={rowIndex} className="d-flex flex-row dealer-row">
                {Array.from({ length: totalColumns ?? 0 }).map(
                  (_, columnIndex) => {
                    const selectedValue = getSelected(rowIndex, columnIndex);
                    return (
                      <div
                        key={columnIndex}
                        className="d-flex flex-column dealer-column"
                      >
                        {Array.from({ length: selectedValue.length }).map(
                          (_, selectFieldIndex) => {
                            return (
                              <select
                                className={`form-select ${selectFieldIndex > 0 ? "mt-2" : ""}`}
                                key={
                                  uniqueId() +
                                  selectFieldIndex +
                                  selectedValue.length
                                }
                                defaultValue={selectedValue[selectFieldIndex]}
                                onChange={(e) => {
                                  const value = parseInt(e.target.value);
                                  updateRouteCustom();
                                  setCustom(true);
                                  setSelected(
                                    rowIndex,
                                    columnIndex,
                                    isNaN(value) ? undefined : value,
                                    selectFieldIndex,
                                  );
                                }}
                              >
                                <option value="">-- Geen --</option>
                                {route.packingSlips.map((packingSlip) => {
                                  return (
                                    <option
                                      key={packingSlip.relation.id}
                                      value={packingSlip.relation.id}
                                    >
                                      {packingSlip.relation.name}
                                    </option>
                                  );
                                })}
                              </select>
                            );
                          },
                        )}
                        {selectedValue.length === 1 && (
                          <Button
                            className="add-dealer-btn"
                            variant="danger"
                            onClick={() => {
                              addEmptyToSelected(rowIndex, columnIndex);
                            }}
                            size="sm"
                          >
                            <Plus fontSize={16} />
                          </Button>
                        )}
                      </div>
                    );
                  },
                )}
              </div>
            );
          })}
          <Button
            className="add-btn add-row-btn"
            variant="danger"
            onClick={() => addRow()}
            size="sm"
          >
            <Plus fontSize={16} />
          </Button>
          <Button
            className="add-btn add-column-btn"
            variant="danger"
            onClick={() => addColumn()}
            size="sm"
          >
            <Plus fontSize={16} />
          </Button>
        </div>
      </Col>
    </Row>
  );
};
